import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useDispatch } from "react-redux";

import { setDiscount } from "@/store/appointments/appointmentsSlice";

import { themeSelector, discauntValues, visitMessage } from "@/utils/constants";

import { IDiscountSelector } from "@/shared/interfaces/service";
import { toast } from "react-toastify";

export default function DiscountSelector({
    id,
    discount,
    isEditAppointment,
    isAppointmentComplete,
}: IDiscountSelector) {
    const dispatch = useDispatch();

    const handleChange = (event: SelectChangeEvent<number>) => {
        if (!isAppointmentComplete) {
            const number = Number(event.target.value);
            dispatch(
                setDiscount({
                    id: id,
                    actualDiscount: number,
                    isEditAppointment: isEditAppointment,
                }),
            );
        } else toast.error(visitMessage);
    };

    return (
        <ThemeProvider theme={themeSelector}>
            <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth sx={{ height: "100%" }}>
                    <InputLabel
                        id='discount-select-label'
                        sx={{ color: "#47586E" }}
                    >
                        Відсоток знижки
                    </InputLabel>
                    <Select
                        labelId='discount-select-label'
                        id='discount-select'
                        value={discount}
                        label='Відсоток знижки'
                        onChange={handleChange}
                        className='input_time_selector'
                        disabled={isAppointmentComplete}
                        sx={{
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#BCC3CD",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1367B5",
                            },
                            height: "100%",
                        }}
                        MenuProps={{
                            disableScrollLock: true,
                            PaperProps: {
                                sx: {
                                    maxHeight: 250,
                                    overflowY: "auto",
                                    marginTop: 1,
                                    padding: 0,
                                    "& ul": {
                                        padding: 0,
                                        margin: 0,
                                    },
                                },
                            },
                        }}
                    >
                        {discauntValues.map(item => (
                            <MenuItem key={item.id} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </ThemeProvider>
    );
}
